import React from 'react';
import { canBuyCard } from '../../helper/GameBoardHelper';
import { Card } from './Card';

export function CardRow({ gameState, myPlayerState, cardLevel, isMyTurn, onBuyCard, onReserveCard, onBlindReserve }) {
  const tier = `level${cardLevel}`;
  const cards = gameState.cards_on_table[tier] || [];
  const deckSize = gameState.decks[cardLevel - 1]?.length || 0;

  return (
    <div className="card-row">
      {/* Deck — click to blind-reserve from top */}
      <div
        className={`card-deck level${cardLevel} ${isMyTurn && deckSize > 0 ? 'clickable' : ''}`}
        onClick={() => isMyTurn && deckSize > 0 && onBlindReserve(tier)}
        title={isMyTurn ? (deckSize > 0 ? `从牌堆顶预定（剩 ${deckSize} 张）` : '牌堆已空') : ''}
      >
        <span>Lv{cardLevel}</span>
        {deckSize > 0 && <span className="deck-count">{deckSize}</span>}
      </div>

      {cards.map(card => (
        <Card
          key={card.id}
          card={card}
          isMyTurn={isMyTurn}
          canBuy={isMyTurn && !!myPlayerState && canBuyCard(card, myPlayerState)}
          onBuy={() => onBuyCard(card)}
          onReserve={() => onReserveCard(card)}
        />
      ))}
    </div>
  );
}

